// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"e4-z","displaySixCardTiles":"f4-z"};